export default defineNuxtRouteMiddleware((to) => {
  const site = to.params.site;

  if (site === 'admin') {
    return navigateTo(`/admin`); // Redirect to the admin route
  }
});
